// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics_statisticsWrapper__x\\+Eec {
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-wrap: wrap;
    overflow: auto;
    padding-bottom: 100px;
    padding-top: 15px;
}

.statistics_statisticsElement__13wiy {

    width: 868px;
    height: 604px;
    box-shadow: 8px 8px 24px 0px #AEAEC066;
    background: #F0F0F3;
    border-radius: 24px;
}

.statistics_statisticsFullElement__Yinp- {
    width: 97.6%;
    display: flex;
    flex-direction: row;
    position: relative;
}

.statistics_statisticsFullElement__Yinp->.statistics_statisticsContent__PtxDB::after {
    content: "";
    position: absolute;
    left: 50%;
    height: 300px;
    width: 2px;
    top: 80px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);

}

.statistics_statisticsContent__PtxDB {
    padding: 30px;
}

.statistics_statisticsTitle__EACb1 {
    font-family: Assistant;
    font-weight: 700;
    font-style: Bold;
    font-size: 18px;
    text-transform: capitalize;

}

.statistics_divider__gWO-s {
    width: 804px;
    height: 2px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);
    margin-top: 20px;
}

/*Colored Statistics*/
.statistics_statisticContent__2xHQL {
    display: flex;
    flex-direction: row;
    gap: 5px;
    margin-top: 1rem;
}

.statistics_statisticItem__GHF1o {
    display: flex;
    flex-direction: column;
    height: 70px;
    position: relative;
}

.statistics_statistiItem__sThyL p {
    font-family: Assistant;
    font-weight: 400;
    font-size: 16px;
    color: #364048;
    white-space: nowrap;
}

.statistics_bar__E1Ov5 {
    height: 40px;
    border-radius: 30px;
    transition: width 0.5s ease;
    margin-top: 10px;
    padding-right: 10px;
}

.statistics_bar__E1Ov5::after {
    content: "";
    position: absolute;
    right: -3px;
    top: 40%;
    margin-top: 6px;
    width: 1px;
    height: 50%;
    background-color: #889096;
}

.statistics_noAfter__5n51f::after {
    display: none;
}

.statistics_bar__E1Ov5 span {
    background: #0000004D;
    padding: 4px 10px;
    display: flex;
    justify-content: center;
    border-radius: 50px;
    width: 65px;
    color: #fff;
    height: 30px;
}


.statistics_statisticTableWrapper__OOupB {
    display: flex;
    flex-direction: row;
    gap: 35px;
    margin-top: 30px;
}

.statistics_statisticTableColumn__Dgp4g {
    width: 377px;
    height: 362px;
    position: relative;
}

.statistics_statisticTableOneColumn__axZCS {
    width: 804px;
    height: 380px;
    position: relative;
    overflow: auto;
}

.statistics_statisticTableTitle__qhgug {
    font-family: Assistant;
    font-weight: 700;
    font-style: Bold;
    font-size: 18px;
    text-transform: capitalize;
    padding-bottom: 10px;
}

.statistics_statisticTableContent__qmHEp {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #CBCBD8;
    padding-bottom: 6px;
    padding-top: 6px;
}

.statistics_statisticTableContent__qmHEp:first-of-type {
    border-bottom: none;
    padding-bottom: 10px;
}

.statistics_statisticTableContent__qmHEp div {
    font-family: Assistant;
    font-weight: 400;
    font-style: SemiBold;
    font-size: 14px;
    color: #364048;

}

.statistics_statisticTableContent__qmHEp:first-of-type div {
    color: #889096;
    font-weight: 600;
}

.statistics_score__txosx {
    font-weight: 700 !important;
}

.statistics_statisticTableColumn__Dgp4g::after {
    content: "";
    position: absolute;
    left: 105%;
    height: 262px;
    width: 2px;
    top: 40px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);

}

.statistics_statisticTableColumn__Dgp4g:last-child::after {
    display: none;
}

.statistics_kpiValue__lMKXN {
    font-family: Assistant;
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    padding-top: 10px;
}

.statistics_legendWrapper__LrbPq {
    display: flex;
    flex-direction: row;
    gap: 35px;
    margin-top: 20px;

}

.statistics_legend__sSeTb {
    font-family: Assistant;
    font-weight: 500;
    font-style: Medium;
    font-size: 18px;
    color: #364048;

}

.statistics_legend__sSeTb:first-child {
    border-right: 1px solid #CBCBD8;
    padding-right: 20px;
}

.statistics_redColoresSquare__A9v7R {
    width: 16px;
    height: 16px;
    background: #F27281;
    border-radius: 4px;
    display: inline-block;
    margin-right: 10px;

}

.statistics_yellowColoresSquare__kYvUn {
    width: 16px;
    height: 16px;
    background: #F5B452;
    border-radius: 4px;
    display: inline-block;
    margin-right: 10px;

}

.statistics_greenColoresSquare__Fmy\\+G {
    width: 16px;
    height: 16px;
    background: #4DC7B5;
    border-radius: 4px;
    display: inline-block;
    margin-right: 10px;

}

.statistics_modalTopWrapper__nu-He {
    display: flex;
    gap: 20px;
    border-bottom: 1px solid #D8D8E0;
    padding-bottom: 25px;
}

.statistics_topLabel__\\+iJbN {
    font-family: Assistant;
    font-weight: 500;
    font-style: Medium;
    font-size: 22px;
}

.statistics_redTriangle__nmW-f {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #F27281;
    border-radius: 4px;
    margin-right: 12px;
    margin-left: 12px;
}

.statistics_greenTriangle__xtSiS {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid #4DC7B5;
    border-radius: 4px;
    margin-right: 12px;
    margin-left: 12px;
}

.statistics_blueSquare__qZto9 {
    width: 0px;
    height: 0px;
    border-left: 6px solid #34b3f1ff;
    border-right: 6px solid #34b3f1ff;
    border-bottom: 6px solid #34b3f1ff;
    border-top: 6px solid #34b3f1ff;
    background-color: #34b3f1ff;
    margin-right: 13px;
    margin-left: 12px;
}

.statistics_modalbottomWrapper__FecVO {
    width: 86%;
}

.statistics_modalbottomWrapper__FecVO>div {
    padding: 25px 0;
    border-bottom: 1px solid #D8D8E0;
}

.statistics_modalbottomWrapper__FecVO>div:last-child {
    border-bottom: none;
}

/*Popup*/
.statistics_assetName__ovQHR {
    font-family: Assistant;
    font-weight: normal;
    font-size: 16px;
    color: #2267A4;
}

.statistics_kpiItem__T-eN2 {
    display: flex;
    justify-content: space-between;
}

.statistics_kpiItem__T-eN2 p {
    width: 80px;
    font-weight: 700;
    font-style: Medium;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.16px;
    vertical-align: middle;

}

/*Custom tooltip*/
.statistics_customTooltip__TfD9N {
    background: #364048;
    padding: 10px 10px;
    width: 63px;
    border-radius: 35px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    pointer-events: none;
    transition: 0.1s ease;
    position: relative;
    text-align: center;
}

.statistics_tooltipTitle__eW4pO {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
}

.statistics_tooltipValue__FrCwL {
    font-size: 14px;
    color: #ffffff;
    font-weight: 700;
    white-space: nowrap;
}

/* Right-side arrow */
.statistics_customTooltip__TfD9N::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -4px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #364048;
}


.statistics_myTooltipBox__W9yKf {
    position: relative;
    background: #364048;
    color: #fff;
    padding: 8px 12px;
    border-radius: 35px;
    font-size: 13px;
}

.statistics_myTooltipArrow__uy92P {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;

    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #364048;
}

.statistics_myTooltipValue__NpX76 {
    font-weight: 600;
}

.statistics_subtitle__oEjfJ {
    font-family: Assistant;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 16px;
    color: #2267A4;
    margin-top: 10px;

}

.statistics_rowClickable__w8c4H {
    position: relative;
    cursor: pointer;
    transition: background 0.2s ease;
    overflow: hidden;
}

.statistics_rowClickable__w8c4H::before {
    content: "";
    position: absolute;
    top: 70%;
    left: 0;
    width: 100%;
    height: 93%;
    background: linear-gradient(90deg, #d6d5d51f, #ffffff, #d6d5d51f);
    transform: translateY(-50%);
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 0;
}

.statistics_rowClickable__w8c4H:hover::before {
    opacity: 1;
}

.statistics_rowClickable__w8c4H>* {
    position: relative;
    z-index: 1;
}



.statistics_customTabs__rb0GL .statistics_ant-tabs-tab-btn__seFwr {
    font-family: 'Assistant', sans-serif !important;
    font-weight: 600 !important;
    font-size: 22px !important;
    color: #500320 !important;
}

.statistics_customTabs__rb0GL .statistics_ant-tabs-tab-active__JEOxn {
    color: #1f1f1f !important;
}

.statistics_customTabs__rb0GL .statistics_ant-tabs-ink-bar__8hBSx {
    background-color: #1f1f1f;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Main/Statiustics/statistics.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV,SAAS;IACT,uGAAuG;;AAE3G;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;;AAE9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uGAAuG;IACvG,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,UAAU;IACV,SAAS;IACT,uGAAuG;;AAE3G;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;;AAEpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gCAAgC;IAChC,iCAAiC;IACjC,kCAAkC;IAClC,+BAA+B;IAC/B,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,QAAQ;AACR;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;;AAE1B;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,+BAA+B;AACnC;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;;IAET,kCAAkC;IAClC,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,iEAAiE;IACjE,2BAA2B;IAC3B,UAAU;IACV,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;;;AAIA;IACI,+CAA+C;IAC/C,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".statisticsWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    flex-wrap: wrap;\n    overflow: auto;\n    padding-bottom: 100px;\n    padding-top: 15px;\n}\n\n.statisticsElement {\n\n    width: 868px;\n    height: 604px;\n    box-shadow: 8px 8px 24px 0px #AEAEC066;\n    background: #F0F0F3;\n    border-radius: 24px;\n}\n\n.statisticsFullElement {\n    width: 97.6%;\n    display: flex;\n    flex-direction: row;\n    position: relative;\n}\n\n.statisticsFullElement>.statisticsContent::after {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    height: 300px;\n    width: 2px;\n    top: 80px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);\n\n}\n\n.statisticsContent {\n    padding: 30px;\n}\n\n.statisticsTitle {\n    font-family: Assistant;\n    font-weight: 700;\n    font-style: Bold;\n    font-size: 18px;\n    text-transform: capitalize;\n\n}\n\n.divider {\n    width: 804px;\n    height: 2px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);\n    margin-top: 20px;\n}\n\n/*Colored Statistics*/\n.statisticContent {\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    margin-top: 1rem;\n}\n\n.statisticItem {\n    display: flex;\n    flex-direction: column;\n    height: 70px;\n    position: relative;\n}\n\n.statistiItem p {\n    font-family: Assistant;\n    font-weight: 400;\n    font-size: 16px;\n    color: #364048;\n    white-space: nowrap;\n}\n\n.bar {\n    height: 40px;\n    border-radius: 30px;\n    transition: width 0.5s ease;\n    margin-top: 10px;\n    padding-right: 10px;\n}\n\n.bar::after {\n    content: \"\";\n    position: absolute;\n    right: -3px;\n    top: 40%;\n    margin-top: 6px;\n    width: 1px;\n    height: 50%;\n    background-color: #889096;\n}\n\n.noAfter::after {\n    display: none;\n}\n\n.bar span {\n    background: #0000004D;\n    padding: 4px 10px;\n    display: flex;\n    justify-content: center;\n    border-radius: 50px;\n    width: 65px;\n    color: #fff;\n    height: 30px;\n}\n\n\n.statisticTableWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 35px;\n    margin-top: 30px;\n}\n\n.statisticTableColumn {\n    width: 377px;\n    height: 362px;\n    position: relative;\n}\n\n.statisticTableOneColumn {\n    width: 804px;\n    height: 380px;\n    position: relative;\n    overflow: auto;\n}\n\n.statisticTableTitle {\n    font-family: Assistant;\n    font-weight: 700;\n    font-style: Bold;\n    font-size: 18px;\n    text-transform: capitalize;\n    padding-bottom: 10px;\n}\n\n.statisticTableContent {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid #CBCBD8;\n    padding-bottom: 6px;\n    padding-top: 6px;\n}\n\n.statisticTableContent:first-of-type {\n    border-bottom: none;\n    padding-bottom: 10px;\n}\n\n.statisticTableContent div {\n    font-family: Assistant;\n    font-weight: 400;\n    font-style: SemiBold;\n    font-size: 14px;\n    color: #364048;\n\n}\n\n.statisticTableContent:first-of-type div {\n    color: #889096;\n    font-weight: 600;\n}\n\n.score {\n    font-weight: 700 !important;\n}\n\n.statisticTableColumn::after {\n    content: \"\";\n    position: absolute;\n    left: 105%;\n    height: 262px;\n    width: 2px;\n    top: 40px;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);\n\n}\n\n.statisticTableColumn:last-child::after {\n    display: none;\n}\n\n.kpiValue {\n    font-family: Assistant;\n    font-weight: 700;\n    font-style: Bold;\n    font-size: 24px;\n    padding-top: 10px;\n}\n\n.legendWrapper {\n    display: flex;\n    flex-direction: row;\n    gap: 35px;\n    margin-top: 20px;\n\n}\n\n.legend {\n    font-family: Assistant;\n    font-weight: 500;\n    font-style: Medium;\n    font-size: 18px;\n    color: #364048;\n\n}\n\n.legend:first-child {\n    border-right: 1px solid #CBCBD8;\n    padding-right: 20px;\n}\n\n.redColoresSquare {\n    width: 16px;\n    height: 16px;\n    background: #F27281;\n    border-radius: 4px;\n    display: inline-block;\n    margin-right: 10px;\n\n}\n\n.yellowColoresSquare {\n    width: 16px;\n    height: 16px;\n    background: #F5B452;\n    border-radius: 4px;\n    display: inline-block;\n    margin-right: 10px;\n\n}\n\n.greenColoresSquare {\n    width: 16px;\n    height: 16px;\n    background: #4DC7B5;\n    border-radius: 4px;\n    display: inline-block;\n    margin-right: 10px;\n\n}\n\n.modalTopWrapper {\n    display: flex;\n    gap: 20px;\n    border-bottom: 1px solid #D8D8E0;\n    padding-bottom: 25px;\n}\n\n.topLabel {\n    font-family: Assistant;\n    font-weight: 500;\n    font-style: Medium;\n    font-size: 22px;\n}\n\n.redTriangle {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 10px solid #F27281;\n    border-radius: 4px;\n    margin-right: 12px;\n    margin-left: 12px;\n}\n\n.greenTriangle {\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 10px solid #4DC7B5;\n    border-radius: 4px;\n    margin-right: 12px;\n    margin-left: 12px;\n}\n\n.blueSquare {\n    width: 0px;\n    height: 0px;\n    border-left: 6px solid #34b3f1ff;\n    border-right: 6px solid #34b3f1ff;\n    border-bottom: 6px solid #34b3f1ff;\n    border-top: 6px solid #34b3f1ff;\n    background-color: #34b3f1ff;\n    margin-right: 13px;\n    margin-left: 12px;\n}\n\n.modalbottomWrapper {\n    width: 86%;\n}\n\n.modalbottomWrapper>div {\n    padding: 25px 0;\n    border-bottom: 1px solid #D8D8E0;\n}\n\n.modalbottomWrapper>div:last-child {\n    border-bottom: none;\n}\n\n/*Popup*/\n.assetName {\n    font-family: Assistant;\n    font-weight: normal;\n    font-size: 16px;\n    color: #2267A4;\n}\n\n.kpiItem {\n    display: flex;\n    justify-content: space-between;\n}\n\n.kpiItem p {\n    width: 80px;\n    font-weight: 700;\n    font-style: Medium;\n    font-size: 14px;\n    line-height: 18px;\n    letter-spacing: 0.16px;\n    vertical-align: middle;\n\n}\n\n/*Custom tooltip*/\n.customTooltip {\n    background: #364048;\n    padding: 10px 10px;\n    width: 63px;\n    border-radius: 35px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n    pointer-events: none;\n    transition: 0.1s ease;\n    position: relative;\n    text-align: center;\n}\n\n.tooltipTitle {\n    font-size: 14px;\n    font-weight: bold;\n    color: #ffffff;\n}\n\n.tooltipValue {\n    font-size: 14px;\n    color: #ffffff;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n/* Right-side arrow */\n.customTooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: -4px;\n    transform: translateY(-50%);\n    width: 0;\n    height: 0;\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid #364048;\n}\n\n\n.myTooltipBox {\n    position: relative;\n    background: #364048;\n    color: #fff;\n    padding: 8px 12px;\n    border-radius: 35px;\n    font-size: 13px;\n}\n\n.myTooltipArrow {\n    content: \"\";\n    position: absolute;\n    bottom: -5px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid #364048;\n}\n\n.myTooltipValue {\n    font-weight: 600;\n}\n\n.subtitle {\n    font-family: Assistant;\n    font-weight: 600;\n    font-style: SemiBold;\n    font-size: 16px;\n    color: #2267A4;\n    margin-top: 10px;\n\n}\n\n.rowClickable {\n    position: relative;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    overflow: hidden;\n}\n\n.rowClickable::before {\n    content: \"\";\n    position: absolute;\n    top: 70%;\n    left: 0;\n    width: 100%;\n    height: 93%;\n    background: linear-gradient(90deg, #d6d5d51f, #ffffff, #d6d5d51f);\n    transform: translateY(-50%);\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    z-index: 0;\n}\n\n.rowClickable:hover::before {\n    opacity: 1;\n}\n\n.rowClickable>* {\n    position: relative;\n    z-index: 1;\n}\n\n\n\n.customTabs .ant-tabs-tab-btn {\n    font-family: 'Assistant', sans-serif !important;\n    font-weight: 600 !important;\n    font-size: 22px !important;\n    color: #500320 !important;\n}\n\n.customTabs .ant-tabs-tab-active {\n    color: #1f1f1f !important;\n}\n\n.customTabs .ant-tabs-ink-bar {\n    background-color: #1f1f1f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statisticsWrapper": `statistics_statisticsWrapper__x+Eec`,
	"statisticsElement": `statistics_statisticsElement__13wiy`,
	"statisticsFullElement": `statistics_statisticsFullElement__Yinp-`,
	"statisticsContent": `statistics_statisticsContent__PtxDB`,
	"statisticsTitle": `statistics_statisticsTitle__EACb1`,
	"divider": `statistics_divider__gWO-s`,
	"statisticContent": `statistics_statisticContent__2xHQL`,
	"statisticItem": `statistics_statisticItem__GHF1o`,
	"statistiItem": `statistics_statistiItem__sThyL`,
	"bar": `statistics_bar__E1Ov5`,
	"noAfter": `statistics_noAfter__5n51f`,
	"statisticTableWrapper": `statistics_statisticTableWrapper__OOupB`,
	"statisticTableColumn": `statistics_statisticTableColumn__Dgp4g`,
	"statisticTableOneColumn": `statistics_statisticTableOneColumn__axZCS`,
	"statisticTableTitle": `statistics_statisticTableTitle__qhgug`,
	"statisticTableContent": `statistics_statisticTableContent__qmHEp`,
	"score": `statistics_score__txosx`,
	"kpiValue": `statistics_kpiValue__lMKXN`,
	"legendWrapper": `statistics_legendWrapper__LrbPq`,
	"legend": `statistics_legend__sSeTb`,
	"redColoresSquare": `statistics_redColoresSquare__A9v7R`,
	"yellowColoresSquare": `statistics_yellowColoresSquare__kYvUn`,
	"greenColoresSquare": `statistics_greenColoresSquare__Fmy+G`,
	"modalTopWrapper": `statistics_modalTopWrapper__nu-He`,
	"topLabel": `statistics_topLabel__+iJbN`,
	"redTriangle": `statistics_redTriangle__nmW-f`,
	"greenTriangle": `statistics_greenTriangle__xtSiS`,
	"blueSquare": `statistics_blueSquare__qZto9`,
	"modalbottomWrapper": `statistics_modalbottomWrapper__FecVO`,
	"assetName": `statistics_assetName__ovQHR`,
	"kpiItem": `statistics_kpiItem__T-eN2`,
	"customTooltip": `statistics_customTooltip__TfD9N`,
	"tooltipTitle": `statistics_tooltipTitle__eW4pO`,
	"tooltipValue": `statistics_tooltipValue__FrCwL`,
	"myTooltipBox": `statistics_myTooltipBox__W9yKf`,
	"myTooltipArrow": `statistics_myTooltipArrow__uy92P`,
	"myTooltipValue": `statistics_myTooltipValue__NpX76`,
	"subtitle": `statistics_subtitle__oEjfJ`,
	"rowClickable": `statistics_rowClickable__w8c4H`,
	"customTabs": `statistics_customTabs__rb0GL`,
	"ant-tabs-tab-btn": `statistics_ant-tabs-tab-btn__seFwr`,
	"ant-tabs-tab-active": `statistics_ant-tabs-tab-active__JEOxn`,
	"ant-tabs-ink-bar": `statistics_ant-tabs-ink-bar__8hBSx`
};
export default ___CSS_LOADER_EXPORT___;
